__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/bdef6d579d3d9fd065b351c9e92993be119e5cfffa4a75d17b176d77/";